import React from "react";

function RssLine() {
	return (
		<g>
			<path d='M3 17C5.20914 17 7 18.7909 7 21H3V17ZM3 10C9.07513 10 14 14.9249 14 21H12C12 16.0294 7.97056 12 3 12V10ZM3 3C12.9411 3 21 11.0589 21 21H19C19 12.1634 11.8366 5 3 5V3Z'></path>
		</g>
	);
}

export default RssLine;
